import { createSlice } from '@reduxjs/toolkit';

type ModalType = 'login' | 'register' | null;

interface ModalState {
  modalType: ModalType;
  wishlistOpen: boolean;
  shoppingCartOpen: boolean;
}

const initialState: ModalState = {
  modalType: null,
  wishlistOpen: false,
  shoppingCartOpen: false,
};

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openLogin: (state) => {
      state.modalType = 'login';
    },
    openRegister: (state) => {
      state.modalType = 'register';
    },
    openWishlist(state) {
      state.wishlistOpen = true;
    },
    closeWishlist(state) {
      state.wishlistOpen = false;
    },
    closeModal: (state) => {
      state.modalType = null;
    },
    openShoppingCart(state) {
      state.shoppingCartOpen = true;
    },
    closeShoppingCart(state) {
      state.shoppingCartOpen = false;
    }
  },
});

export const {
  openLogin,
  openRegister,
  closeModal,
  openWishlist,
  closeWishlist,
  openShoppingCart,
  closeShoppingCart
} = modalSlice.actions;

export default modalSlice.reducer;